export function moduleTypeBadgeClass(type: string) {
  if (type === "mask") return "bg-blue-500/15 text-blue-300 border-blue-500/30"
  if (type === "score") return "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"
  if (type === "image_label") return "bg-amber-500/15 text-amber-300 border-amber-500/30"
  if (type === "vector") return "bg-cyan-500/15 text-cyan-300 border-cyan-500/30"
  if (type === "text") return "bg-rose-500/15 text-rose-300 border-rose-500/30"
  if (type === "annotation_time") return "bg-indigo-500/15 text-indigo-300 border-indigo-500/30"
  if (type === "voice_note") return "bg-orange-500/15 text-orange-300 border-orange-500/30"
  return "bg-muted text-muted-foreground"
}

export function formatModuleType(type: string) {
  if (type === "mask") return "Segmentation"
  if (type === "score") return "Scoring"
  if (type === "image_label") return "Image labels"
  if (type === "vector") return "Drawing"
  if (type === "text") return "Notes"
  if (type === "annotation_time") return "Time tracking"
  if (type === "label_raster") return "Label raster"
  if (type === "voice_note") return "Voice notes"
  return type.replace("_", " ")
}

export function formatDependencyMode(mode: string) {
  if (mode === "completion_only") return "After completion"
  if (mode === "instance_linked") return "Match related findings"
  return mode.replace("_", " ")
}

export function formatDependencyCardinality(cardinality: string) {
  if (cardinality === "one_to_one") return "One related item"
  if (cardinality === "one_to_many_min1") return "One or more related items"
  return cardinality.replace("_", " ")
}

export function formatStatus(status: string) {
  if (status === "draft") return "Draft"
  if (status === "active") return "Active"
  if (status === "paused") return "Paused"
  if (status === "completed") return "Completed"
  if (status === "archived") return "Archived"
  return status
}

export function formatMode(mode: string) {
  if (mode === "standard") return "Standard"
  if (mode === "queued") return "Queued"
  return mode
}

export function formatWorkflow(workflow: string) {
  if (workflow === "radiology") return "Radiology (NiiVue)"
  if (workflow === "pathology") return "Pathology (WSI)"
  return workflow
}

export function formatSortType(type: string) {
  if (type === "integer") return "Integer"
  if (type === "float") return "Float"
  return type
}

export function formatSortDirection(direction: string) {
  if (direction === "asc") return "Ascending"
  if (direction === "desc") return "Descending"
  return direction
}

export function formatInstanceRole(role: string) {
  if (role === "admin") return "Admin"
  if (role === "member") return "Member"
  return role
}

export function formatProjectRole(role: string) {
  if (role === "project_admin") return "Admin"
  if (role === "annotator") return "Annotator"
  if (role === "reviewer") return "Reviewer"
  if (role === "viewer") return "Viewer"
  return role
}

export function prettyPrintJson(value: string) {
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch {
    return value
  }
}

export function tryParseSchema(value: string): Record<string, unknown> | null {
  try {
    const parsed = JSON.parse(value)
    if (!parsed || typeof parsed !== "object") return null
    return parsed as Record<string, unknown>
  } catch {
    return null
  }
}
